import { createContext, memo } from 'react';
import { createStore } from './externalStore';
export var mutationsContext = createContext({});
export var MutationsProvider = memo(mutationsContext.Provider);
export var actionsContext = createContext({});
export var ActionsProvider = memo(actionsContext.Provider);
export var globalStoreContext = createContext(createStore({}));
export var GlobalStoreProvider = memo(globalStoreContext.Provider);
export var globalGettersContext = createContext({
    current: createStore({})
});
export var GlobalGettersProvider = globalGettersContext.Provider;
